/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable no-confusing-arrow */
import { NavLink } from 'react-router-dom';
import styled from 'styled-components';

export const Container = styled.div`
  height: 100%;
  width: 100%;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 10px;
  margin-bottom: 30px;
`;

export const HeaderItems = styled.div`
  display: flex;
  align-items: center;
  gap: 15px;
`;

export const NavTextLink = styled(NavLink)`
  text-decoration: none;
  color: black;
  &.active {
    color: #2dcafc;
  }
`;

export const PageTitle = styled.span`
  font-family: BiotifSemiBold;
  font-size: 24px;
`;

export const ArrowBack = styled.img`
  height: 20px;
  width: auto;
`;

export const Title = styled.span`
  align-self: flex-start;
  font-family: BiotifSemiBold;
  font-size: 28px;
  padding-bottom: 10px;
`;

export const ReportsContainer = styled.div`
  display: flex;
  align-self: flex-start;
  flex-direction: column;
`;

export const TabContainer = styled.div`
  display: flex;
  gap: 20px;
`;

export const Tab = styled.div<{ selected: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 246px;
  height: 45px;
  background: ${({ selected }) =>
    selected ? '#fff 0% 0% no-repeat padding-box' : '#c9cbd3 0% 0% no-repeat padding-box'};
  border-radius: 4px 4px 0px 0px;
  font: normal normal normal 16px/24px Biotif;
`;

export const ColumnTitle = styled.div`
  white-space: pre-line;
  word-wrap: break-word;
`;

export const SearchStyle = styled.div`
  margin-top: '22px';
  width: 250px;
  div {
    max-width: 250px;
  }
  input {
    max-height: 40px;
  }
`;

export const TabTitle = styled.div``;
